<template>
  <label class="etiqueta--campo"> {{ texto }} <label class="etiqueta--campo__marca" v-if="requerido"> *</label> </label>
</template>

<script>
export default {
  props: {
    texto: String,
    requerido: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="css" scoped>
.etiqueta--campo {
  color: #1E2120;
  font-size: 16px;
  text-align: start;
  width: 100%;
  margin-bottom: 3px;
}
.etiqueta--campo__marca {
    color: #FF0000;
}

@media all and (max-width: 767px){
  .etiqueta--campo {
    font-size: 14px;
  }
}
</style>
